import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';

import Contact from './pages/Contact';
import Home from './pages/Home';
import Gift from './pages/Gift';
import MrFitFastFoodSaudavel from './pages/Gifts/MrFitFastFoodSaudavel';
import HongKongSelf from './pages/Gifts/HongKongSelf';

function App() {
  return (
    <Router>
      <Header />

      <Switch>
        <Route path="/loja-do-igor">
          <Gift />
        </Route>
        <Route path="/mr-fit-fast-food-saudavel">
          <MrFitFastFoodSaudavel />
        </Route>
        <Route path="/hong-kong-selfs-restaurante">
          <HongKongSelf />
        </Route>
        <Route path="/contato">
          <Contact />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>

      <Footer />
    </Router>
  );
}

export default App;
